import { LessonCourseDefaultThumbnail } from '@/constant/imgImport';
import { useFetchCourseDetails } from '@/hooks/course/useFetchCourseDetails';
import { useScreen } from '@/hooks/useScreen';
import { EPurchaseProductType } from '@/interfaces/order.interface';
import { ICourseDetailResponse } from '@/interfaces/training.interface';
import { moneyFormat } from 'common/numberHelpers';
import { parseTMSTimeStamp } from 'common/timestamp';
import { Typography } from 'design-system/components/Typography';
import Image from 'next/image';
import PurchaseSection from '.';

const PurchaseForCourseOnly = ({
  open,
  toggle,
}: {
  open: boolean;
  toggle: () => void;
}) => {
  const { isDesktop } = useScreen();

  const {
    queryReturn: { data },
  } = useFetchCourseDetails();

  return (
    <PurchaseSection
      open={open}
      toggle={toggle}
      price={data?.coursePrice?.price || 0}
      productId={data?.id || ''}
      productType={EPurchaseProductType.Course}
    >
      {isDesktop ? (
        <div className="flex w-full flex-col items-center gap-6 border-r border-Other/Outlinedborder-stroke/30 py-4 pr-5">
          <div className="w-[355px]">
            <CourseThumbnail course={data} />
          </div>
          <CourseInfo course={data} />
        </div>
      ) : (
        <>
          <div className="w-[343px]">
            <CourseThumbnail course={data} />
          </div>
          <div className="mb-8 mt-4 w-full">
            <CourseInfo course={data} />
          </div>
        </>
      )}
    </PurchaseSection>
  );
};

export default PurchaseForCourseOnly;

function CourseThumbnail({ course }: { course?: ICourseDetailResponse }) {
  return (
    <div className="group relative flex aspect-video items-start justify-center overflow-hidden rounded-lg">
      <Image
        src={
          course?.thumbnail ? course?.thumbnail : LessonCourseDefaultThumbnail
        }
        layout="fill"
        objectFit="cover"
        alt="default thumbnail"
      />
    </div>
  );
}

function CourseInfo({ course: data }: { course?: ICourseDetailResponse }) {
  return (
    <div className="flex w-full flex-col gap-2 text-sm font-medium leading-[120%] text-Text/Lightbackground/Primary">
      <Typography variant="body3">Thông tin khoá học</Typography>
      <Typography variant="heading1">{data?.title}</Typography>
      <div className="flex flex-col gap-2 border-b border-[#E0E0E0] pb-4 text-Text/Lightbackground/Primary md:grid md:grid-cols-10 md:gap-0">
        <div className="flex flex-col border-r border-[#EFEFEF] md:col-span-3 md:items-center">
          {data?.lessonCount && (
            <Typography variant="body3" className="border-l border-[#EFEFEF]">
              Số lượng bài học:{' '}
              {data?.lessonCount > 9
                ? data?.lessonCount
                : `0${data?.lessonCount}`}
            </Typography>
          )}
        </div>
        <div className="flex flex-col border-l border-r border-[#EFEFEF] md:col-span-3 md:items-center">
          {data?.certificateShortName && (
            <Typography variant="body3">
              Loại chứng chỉ: {data?.certificateShortName}
            </Typography>
          )}
        </div>
        <div className="flex flex-col border-l border-[#EFEFEF] md:col-span-4 md:items-center">
          {data?.totalDuration && (
            <Typography variant="body3">
              Tổng thời gian:{' '}
              {parseTMSTimeStamp(data?.totalDuration, {
                includeSecond: false,
              })}
            </Typography>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between text-sm font-medium leading-[120%] text-Text/Lightbackground/Secondary">
        <Typography variant="body3">Giá</Typography>
        <Typography variant="body1">
          {moneyFormat(data?.coursePrice?.price || 0)} VNĐ
        </Typography>
      </div>
    </div>
  );
}
